import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b82a8fb2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "order-container" }
const _hoisted_2 = {
  key: 0,
  class: "",
  style: {"margin":"10px 0px 10px 10px"}
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "dialog-footer" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("取消")

import { ref, reactive, nextTick } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { inMethods, Result, ResultNumber } from "./receivingRecord";
import {
  getReceiveRecord,
  getPageList,
  getPurchaseCollectList
} from "@/service/main/statistical";
import { getSysDicListData } from "@/service/main/system/dic";
import { purchaseOrderType } from "@/service/main/invoices/purchasetype";
import Pagination from "@/components/Pagination/index.vue";
import { exportExcel } from "@/utils/exportExcel";
//import type { FormRules } from 'element-plus';
//父级传递来的参数
// const props = defineProps({
// 	comperateType: {
// 		type: String,
// 		default: 'add',
// 	},
// });

export default /*#__PURE__*/_defineComponent({
  emits: ["reloadTable"],
  setup(__props, { expose, emit }) {

const isEnum: any = ref([
  { label: "全部", value: -10 },
  { label: "是", value: 1 },
  { label: "否", value: 0 }
]);
const qualityEnum: any = ref([
  { label: "全部", value: -10 },
  { label: "合格", value: 1 },
  { label: "返修", value: 2 },
  { label: "报废", value: 3 },
  { label: "技术确认", value: 4 },
  { label: "让步接收", value: 5 },
  { label: "退货", value: 6 },
  { label: "免检", value: 7 }
]);
const storeEnum = ref([]);
const getIsEmptyContainerData = () => {
  const obj = {
    //Code: "yes_or_no", //字典里 加采购类型
    PageNo: 1,
    PageSize: 20
  };
  purchaseOrderType(obj)
    .then((res) => {
      if (res.code == 200) {
        const { data } = res;
        const result = data;
        storeEnum.value = result.rows;
      } else {
        ElMessage.error(`${res.code}:${res.message}`);
      }
    })
    .catch((err) => {
      ElMessage.error(err);
    });
};

getIsEmptyContainerData();
// 改变Table某一列的背景颜色
const columnbackgroundStyle = (
  row: any,
  column: number,
  rowIndex: number,
  columnIndex: number
) => {
  if (row.column.label == "待检验数量" || row.column.label == "待入库数量") {
    return "background: #DBDB70;font-weight: bold;";
  }
};
//父级传递来的函数，用于回调


const isShowDialog = ref(false);
const loadingVisable = ref(false);

//查询
const formModel = reactive({
  PageNo: 1,
  PageSize: 20,
  purchaseType: "",
  purchaseNo: "",
  specificationModel:'',
  collectType: "",
  DeliveryNo: "",
  isQuality: -10,
  ProjectCode: "",
  isWarehousing: -10,
  qualityResult: -10,
  waitTestNumber:"",
  waitInNumber:"",
});

//收货记录查询列表
let detailData = ref([]);

//收货记录查询列表的数据条数
const totalItems = ref<number>(0);
//获取菜单列表
const getTabelData = () => {
  getPurchaseCollectList(formModel).then((res) => {
    const { data } = res;
    const arr: any = [];
    
    data?.rows.forEach((item: any) => {
      arr.push({
        projectCode: item.projectCode,
        purchaseNo: item.purchaseNo,
        code: item.code,
        name: item.name,
        supplierInfoName: item.supplierInfoName,
        purchaserUserName: item.purchaserUserName,
        purchaserNumber: item.purchaserNumber,
        collectQuantity: item.collectQuantity,
        isQuality: item.isQuality,
        waitTestNumber: item.waitTestNumber,
        qualityResult: item.qualityResult,
        waitInNumber: item.waitInNumber,
        inQuantity: item.inQuantity,
        estimateTime:item.estimateTime
        // collectType: item.collectType,
        // deliveryNo: item.deliveryNo,
        // specificationModel: item.specificationModel,
        // inspectionMethod: item.inspectionMethod,
        // brandName: item.brandName,

        // isQualified: item.isQualified,
        // supplierInfoCode: item.supplierInfoCode,
        // createdTime: item.createdTime,
        // materialTagCode: item.materialTagCode,
        // qualityNumber: item.qualityNumber,
        // warehousingQuantity: item.warehousingQuantity,
        // hege: ResultNumber(item),
        // djQuantity: item.djQuantity,
        // qualityResultName: Result(item.qualityResult)
      });
    });
    detailData.value = arr;
    totalItems.value = data.totalRows;
    loadingVisable.value = false;
  });
};

// 打开弹窗
// const openDialog = (deliveryNo:any,purchaseType:any) => {
//     formModel.PurchaseNo = deliveryNo
//     formModel.PurchaseType = purchaseType
//     isShowDialog.value = true;
//     getTabelData();
//   }
const openDialog = (ProjectCode: any) => {
  formModel.ProjectCode = ProjectCode;
  isShowDialog.value = true;
  loadingVisable.value = true;
  
  getTabelData();
};

//关闭窗口
const handlerClose = () => {
  selfClose();
  isShowDialog.value = false;
  loadingVisable.value = false;
};
const selfClose = function () {
  formModel.PageNo = 1;
  formModel.PageSize = 20;
  formModel.purchaseNo = "";
  formModel.specificationModel = "";
  formModel.purchaseType = "";
  formModel.collectType = "";
  formModel.DeliveryNo = "";
  formModel.isQuality = -10;
  formModel.isWarehousing = -10;
  formModel.qualityResult = -10;
  formModel.waitInNumber = "";
  formModel.waitTestNumber = "";
};
//导出确认按钮
const locallistExport = (num: number) => {
  let entozh = {
    projectCode: "项目号",
    purchaseNo: "采购单号",
    // collectType: "采购类型",
    // deliveryNo: "送货单号",
    // supplierInfoCode: '供应商',
    // createdTime: '收货时间',
    // xuHao: '序号',
    code: "品号",
    name: "品名",
    supplierInfoName: "供应商",
    purchaserUserName: "采购人",
    purchaserNumber: "采购数量",
    // specificationModel: "规格型号",
    // unit: "单位",
    // inspectionMethod: "检验方式",
    // brandName: '品牌名称',
    collectQuantity: "收货数量",
    isQuality: "是否质检",
    waitTestNumber: "待检天数",
    qualityResultName: "质检结果",
    // qualityNumber: "质检结果数量",
    // updatedTime: "质检时间",
    // hege: "合格数",
    // drQuantity: "待入库数量",
    waitInNumber: "待入库天数",
    inQuantity: "已入库数量"
  };
  if (detailData.value.length !== 0) {
    exportExcel(detailData.value, entozh, "xlsx", "物料状态表");
  }
};
Result;
//将属性或者函数暴露给父组件
expose({ openDialog });

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_dialog, {
      modelValue: isShowDialog.value,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((isShowDialog).value = $event)),
      onClose: handlerClose,
      title: '物料进行状态——项目号： ' + _unref(formModel).ProjectCode,
      width: "80%"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_8, [
          _createVNode(_component_el_button, { onClick: handlerClose }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        (!loadingVisable.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_el_form, {
                model: _unref(formModel),
                "label-width": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_row, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_col, { span: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "采购类型:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _unref(formModel).purchaseType,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(formModel).purchaseType) = $event)),
                                placeholder: "请选择",
                                size: "large",
                                clearable: "",
                                style: {"width":"100%"}
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(storeEnum.value, (item) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: item.typeCode,
                                      label: item.typeName,
                                      value: item.typeCode
                                    }, null, 8, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 3,
                        class: "marginleft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "采购单号:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(formModel).purchaseNo,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(formModel).purchaseNo) = $event)),
                                placeholder: "请输入",
                                size: "large",
                                style: {"width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 3,
                        class: "marginleft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "规格:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(formModel).specificationModel,
                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(formModel).specificationModel) = $event)),
                                placeholder: "请输入",
                                size: "large",
                                style: {"width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 3,
                        class: "marginleft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "待检天数:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(formModel).waitTestNumber,
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(formModel).waitTestNumber) = $event)),
                                placeholder: "请输入",
                                size: "large",
                                style: {"width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 3,
                        class: "marginleft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, { label: "待入天数:" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_input, {
                                modelValue: _unref(formModel).waitInNumber,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(formModel).waitInNumber) = $event)),
                                placeholder: "请输入",
                                size: "large",
                                style: {"width":"100%"}
                              }, null, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_col, {
                        span: 6,
                        class: "marginleft"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                icon: "el-icon-search",
                                onClick: getTabelData
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                icon: "el-icon-refresh-right",
                                onClick: selfClose
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_el_button, {
                                type: "warning",
                                onClick: locallistExport
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_5
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]))
          : _createCommentVNode("", true),
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          data: _unref(detailData),
          style: {"width":"100%"},
          "tooltip-effect": "light",
          "row-key": "id",
          border: "",
          "cell-style": columnbackgroundStyle,
          "header-cell-style": columnbackgroundStyle,
          height: 600
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              fixed: "",
              label: "序号",
              type: "index",
              align: "center",
              width: "60"
            }),
            _createVNode(_component_el_table_column, {
              label: "采购单号",
              prop: "purchaseNo",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "品号",
              prop: "code",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "品名",
              prop: "name",
              align: "center",
              width: "250"
            }),
            _createVNode(_component_el_table_column, {
              label: "供应商",
              prop: "supplierInfoName",
              align: "center",
              width: "250"
            }),
            _createVNode(_component_el_table_column, {
              label: "采购人",
              prop: "purchaserUserName",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "采购数量",
              prop: "purchaserNumber",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "预计到货时间",
              prop: "estimateTime",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "收货数量",
              prop: "collectQuantity",
              align: "center",
              width: ""
            }),
            _createVNode(_component_el_table_column, {
              label: "是否质检",
              prop: "isQuality",
              align: "center",
              width: ""
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.isQuality == 1 ? "是" : "否"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "待检天数",
              prop: "waitTestNumber",
              width: "",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "质检结果",
              prop: "qualityResult",
              align: "center",
              width: ""
            }, {
              default: _withCtx((scope) => [
                (scope.row.qualityResult)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(Result)(scope.row.qualityResult)), 1))
                  : (_openBlock(), _createElementBlock("span", _hoisted_7))
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "待入库天数",
              prop: "waitInNumber",
              width: "",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "已入库数量",
              prop: "inQuantity",
              width: "",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"])), [
          [_directive_loading, loadingVisable.value]
        ]),
        _createVNode(Pagination, {
          total: totalItems.value,
          page: _unref(formModel).PageNo,
          "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => ((_unref(formModel).PageNo) = $event)),
          limit: _unref(formModel).PageSize,
          "onUpdate:limit": _cache[6] || (_cache[6] = ($event: any) => ((_unref(formModel).PageSize) = $event)),
          onPagination: getTabelData,
          style: {"margin-top":"20px","text-align":"right"},
          pageSizes: [10, 50, 100, 500, 1000]
        }, null, 8, ["total", "page", "limit"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})